<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <!-- Names -->
                <div class="d-flex flex-wrap">
                    <div role="group" class="form-group col-12 col-md-6">
                    <label class=""> {{ $t('nameMandatory') }}</label>
                        <CInput class="m-0" type="text" v-model="category.names[currentLanguage.key]" :invalid-feedback="errorOutput['Name']" :is-valid="genericValidator(category.names, attemptedSubmit) && errorValidator('Name')"></CInput>
                    </div>
                    <!-- Type -->
                    <div role="group" class="form-group col-12 col-md-6">
                    <label class=""> {{ $t('typeMandatory') }}</label>
                        <SingleOptionDropdown v-model="category.type" :options="typeOptions" :title="$t('type')" :index="0" :is-valid="genericValidator(category.type, attemptedSubmit) && errorValidator('Type')" :invalid-feedback="errorOutput['Type']"></SingleOptionDropdown>
                    </div>
                    <!-- Color -->
                    <div role="group" class="form-group col-12 col-md-6">
                    <label class=""> {{ $t('colorMandatory') }}</label>
                        <CInput class="color-input m-0" type="color" :title="$t('colors')" v-model="category.color" :is-valid="genericValidator(category.color, attemptedSubmit) && errorValidator('Colors')" :invalid-feedback="errorOutput['Colors']"/>
                    </div>
                </div>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState } from 'vuex'
import router from '@/router/index';

import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";

import Category from "@/classes/Category";

import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

import FormLoading from '@/controls/FormLoading.vue'

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, SingleOptionDropdown, FormLoading },
    props:{    
        baseCategory:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            category: new Category({}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
            typeOptions: [ {label: this.$t("news"), key: "News"}, {label: this.$t("event"), key: "Event"}, {label: this.$t("pois"), key: "Poi"}, {label: this.$t("product"), key: "Product"}, {label: this.$t("route"), key: "Route"} ],
        }
    },
    mounted: function()
    {
        this.resetCategory();
    },
    computed:
    {
        ...mapState('categories', ['putCategoryOutput']),
        ...mapState('categories', ['postCategoryOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
             var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.category.names)) { if(!value) { result['Name'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        name: function () {
            return this.baseCategory || this.baseName ? (this.baseCategory ? this.baseCategory.name : this.baseName) : null;
        }
    },
    methods:{
        genericValidator,
        errorValidator,
        resetCategory(){
            if(!this.baseCategory)
            {
                var names = {};
                CONSTANTS.supportedLanguages.forEach(language => { names[language.key] = "" });
                this.category = new Category(names);
            }
            else
            {
                this.category = deepClone(new Category, this.baseCategory);  
                this.category.type = this.$route.query.type;
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.category.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.category);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: "Categories"});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putCategoryOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postCategoryOutput: function(val)
        {
            this.onProcessTask(val);
        },
        baseCategory: function()
        {
            this.resetCategory();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
</style> 